import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { IoMdClose, IoMdCloseCircle } from "react-icons/io";
import { MdAddBox } from "react-icons/md";
import * as Yup from "yup";
import { IProvider } from "..";
import api from "../../../service/api";
import Modal from "../../ModalLib";
import { RowNone, TabletSelect } from "./styles";

import {
  ContainerList,
  Filter,
  FilterCheck,
  FilterSelects,
  FooterContainer,
  Form,
  MainFilter,
  ModalBody,
  TableContainer,
} from "../../../pages/create/styles";

interface IPagination {
  total: number;
  limit: number;
  page: number;
  pages: number;
}

interface IResponseAPI {
  contents: IProvider[];
  total: number;
  limit: number;
  page: number;
  pages: number;
}

interface IRequestPagination {
  limitRequest?: number;
  pageRequest?: number;
}

interface ProviderComponentProps {
  setProvidersLinks: React.Dispatch<React.SetStateAction<IProvider[]>>;
  providersLinks: IProvider[];

  disabled?: boolean;
}

interface IFilter {
  id?: string;
  cod?: string;
  fullname?: string;
  email?: string;
}

export const SelectProvider: React.FC<ProviderComponentProps> = ({
  setProvidersLinks,
  providersLinks,

  disabled = false,
}) => {
  const outSideRefFilter = useRef(null);

  const [isDisabledModal, setIsDisabledModal] = useState<boolean>(false);

  const [providers, setProviders] = useState<IProvider[]>([]);
  const [filters, setFilters] = useState<IFilter>({});
  const [filterView, setFilterView] = useState(false);

  const [modalVisibleProvider, setModalVisibleProvider] = useState(false);
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [requestPagination, setRequestPagination] =
    useState<IRequestPagination>({ limitRequest: 10 } as IRequestPagination);

  const formikFilter = useFormik({
    initialValues: {
      id: filters.id,
      cod: filters.cod,
      fullname: filters.fullname,
      email: filters.email,
    },

    validationSchema: Yup.object({}),

    onSubmit: (data) => {
      hadleFilter(data);
    },
  });

  useEffect(() => {
    (async () => {
      try {
        const providersDB = await api.get<IResponseAPI>("/provider", {
          params: { ...requestPagination, ...filters },
        });

        const { limit, page, pages, total } = providersDB.data;

        setProviders(providersDB.data.contents);
        setPagination({ limit, page, pages, total });
      } catch (error) {}
    })();
    // eslint-disable-next-line
  }, [filters, requestPagination]);

  function hadleNextPage() {
    setRequestPagination({
      ...requestPagination,
      pageRequest: pagination.page + 1,
    });
  }
  function hadlePreviousPage() {
    setRequestPagination({
      ...requestPagination,
      pageRequest: pagination.page - 1,
    });
  }
  function hadleFilter(filter: IFilter) {
    setFilters(filter);
    setFilterView(false);
  }

  function handleSelectProvider(provider: IProvider) {
    const existProvider = providersLinks.find((f) => f.id === provider.id);

    if (!existProvider) {
      setProvidersLinks([...providersLinks, provider]);
    }

    if (!isDisabledModal) setModalVisibleProvider(false);
  }
  function handleRemoveProvider(provider: IProvider) {
    const providersNoRemove = providersLinks.filter(
      (f) => f.id !== provider.id
    );

    setProvidersLinks([...providersNoRemove]);
  }

  return (
    <>
      <div className="container-subtitle">
        <h3>Fornecedores</h3>

        {!disabled && (
          <button
            type="button"
            className="action-button"
            onClick={() => {
              setModalVisibleProvider(true);
            }}
          >
            <MdAddBox />
          </button>
        )}
      </div>

      <TabletSelect>
        <thead>
          <tr>
            <th>ID</th>
            <th>Cód ERP</th>
            <th>Nome</th>
            <th>Email</th>
            {!disabled && <th>Ação</th>}
          </tr>
        </thead>

        <tbody>
          {providersLinks.map((provider, indexData) => (
            <tr key={indexData}>
              <td>{provider.id}</td>
              <td>{provider.cod}</td>
              <td>{provider.fullname}</td>
              <td>{provider.email}</td>
              {!disabled && (
                <td>
                  <button
                    type="button"
                    className="action-button"
                    onClick={() => {
                      handleRemoveProvider(provider);
                    }}
                  >
                    <IoMdClose />
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </TabletSelect>

      {providersLinks.length < 1 && (
        <RowNone>Não há registros a serem exibidos</RowNone>
      )}

      <Modal
        title="Vincular fornecedor"
        modalVisible={modalVisibleProvider}
        setModalVisible={setModalVisibleProvider}
        maxWidth={1400}
        maxHeight={800}
        isDisabled={isDisabledModal}
        setIsDisabled={setIsDisabledModal}
      >
        <ModalBody>
          <Filter>
            <button
              onClick={() => {
                setFilterView(!filterView);
              }}
              type="button"
            >
              <FiSearch />
            </button>
            <input
              onClick={() => {
                setFilterView(!filterView);
              }}
              type="text"
              name="filter"
              id="filter"
              readOnly={true}
            />
            <FilterSelects>
              <ul>
                {filters.id && (
                  <li>
                    <span>ID: {filters.id}</span>{" "}
                    <IoMdCloseCircle
                      onClick={() => setFilters({ ...filters, id: "" })}
                    />
                  </li>
                )}

                {filters.cod && (
                  <li>
                    <span>Código ERP: {filters.cod}</span>{" "}
                    <IoMdCloseCircle
                      onClick={() => setFilters({ ...filters, cod: "" })}
                    />
                  </li>
                )}
                {filters.fullname && (
                  <li>
                    <span>Nome: {filters.fullname}</span>{" "}
                    <IoMdCloseCircle
                      onClick={() => setFilters({ ...filters, fullname: "" })}
                    />
                  </li>
                )}

                {filters.email && (
                  <li>
                    <span>Email: {filters.email}</span>{" "}
                    <IoMdCloseCircle
                      onClick={() => setFilters({ ...filters, email: "" })}
                    />
                  </li>
                )}
              </ul>
            </FilterSelects>

            {filterView && (
              <FilterCheck ref={outSideRefFilter}>
                <MainFilter>
                  <Form onSubmit={formikFilter.handleSubmit}>
                    {/* <div className="field-group">
                      <div className="field">
                        <label htmlFor="id">ID</label>
                        <input id="id" {...formikFilter.getFieldProps("id")} />
                      </div>
                      <div className="field">
                        <label htmlFor="cod">Código ERP</label>
                        <input
                          id="cod"
                          {...formikFilter.getFieldProps("cod")}
                        />
                      </div>
                    </div> */}

                    <div className="field-group">
                      <div className="field">
                        <label htmlFor="fullname">Nome</label>
                        <input
                          id="fullname"
                          {...formikFilter.getFieldProps("fullname")}
                        />
                      </div>
                      {/* <div className="field">
                        <label htmlFor="email">Email</label>
                        <input
                          id="email"
                          {...formikFilter.getFieldProps("email")}
                        />
                      </div> */}
                    </div>

                    <footer>
                      <button
                        className="clearFilter"
                        type="button"
                        onClick={() => {
                          setFilterView(false);
                          setFilters({});
                        }}
                      >
                        LIMPAR FILTRO
                      </button>
                      <button type="submit">BUSCAR</button>
                    </footer>
                  </Form>
                </MainFilter>
              </FilterCheck>
            )}
          </Filter>
          <ContainerList>
            <TableContainer>
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>CÓD.ERP</th>
                    <th>NOME</th>
                    <th>EMAIL</th>
                    <th>MARCA</th>
                  </tr>
                </thead>

                <tbody>
                  {providers.map((provider: IProvider) => (
                    <tr
                      key={provider.id}
                      onClick={() => handleSelectProvider(provider)}
                    >
                      <td> {provider.id} </td>
                      <td> {provider.cod} </td>
                      <td> {provider.fullname} </td>
                      <td> {provider.email} </td>
                      <td> {provider.brand} </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </TableContainer>
            <FooterContainer>
              <span>
                Mostrando {providers.length} de {pagination.total} resultados
              </span>

              <div>
                <button
                  className={pagination.page <= 0 ? "buttonNull" : ""}
                  type="button"
                  onClick={pagination.page <= 0 ? () => {} : hadlePreviousPage}
                >
                  ANTERIOR
                </button>
                <p style={{ marginRight: 8 }}>{pagination.page + 1}</p>
                <button
                  className={
                    pagination.page >= pagination.pages ? "buttonNull" : ""
                  }
                  type="button"
                  onClick={
                    pagination.page >= pagination.pages
                      ? () => {}
                      : hadleNextPage
                  }
                >
                  PROXIMO
                </button>
              </div>
            </FooterContainer>
          </ContainerList>
        </ModalBody>
      </Modal>
    </>
  );
};
